import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types/api';

export interface BookingCancelReason {
  id: number;
  type: string;
  label: string;
  description?: string;
}

const URL = '/v2/booking-cancel-reasons';

class BookingCancelReasonsService {
  static getByFilter(
    config?: AxiosRequestConfig,
  ): Promise<PagedResponse<BookingCancelReason>> {
    return axios.get(URL, config);
  }
}

export { BookingCancelReasonsService };
